export const getNameInitials = (name: string) =>
  name
    .split(' ')
    .map((item) => item.substring(0, 1))
    .join('')
    .toUpperCase();
